var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticStyle: {
      "flex-grow": "0"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "to": _vm.hasPrev ? "/auction-works/".concat(_vm.work.meta._prev) : null,
      "disabled": !_vm.hasPrev
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1)], 1), _vm.is(_vm.PROGRAM) ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "to": "/auction-halls/".concat(_vm.work.meta.hall, "/groups/all"),
      "disabled": _vm.isEnded
    }
  }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)], 1)] : _vm._e(), _vm.is(_vm.PRIVATE) ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "to": "/private-sales/LIST",
      "disabled": _vm.isEnded
    }
  }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)], 1)] : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "to": _vm.hasNext ? "/auction-works/".concat(_vm.work.meta._next) : null,
      "disabled": !_vm.hasNext
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }